'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import * as Styled from './cover.styled';
const DEFAULT_COVER_SRC = 'https://cdn-gpd.x-plarium.com/browser/content/portal/common/profile/games/pp-3.webp';
export const Cover = React.memo(function Cover() {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  return <Styled.Container>
      <Styled.CoverImage src={profileModel.images?.coverBackgroundProfile?.src || DEFAULT_COVER_SRC} alt="Profile background" priority={true} fill={true} />
    </Styled.Container>;
});